import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'
import type { ShowMeta } from '@nuxtDatakodeUtils/types/Api/Response/ShowMeta'
import type { ApplicationTable } from '~/models/ApplicationTable'
import type { Application } from '~/models/Application'

type GenericApplicationData = PildomModules.Generic.Data.GenericApplicationData

export class Entity extends BaseModel<any> { // no type for
    override endPoint: string = 'generic/{application_slug}/tables/{application_table_slug}/entities'
    override permissionName: string = 'APP_{application_name}_magicModel'
    override translationKey: string = 'generic'

    public application: Application | null = null
    public table: ApplicationTable | null = null

    constructor(table: ApplicationTable | null = null) {
        super()
        if (table) {
            this.application = table?.application
            this.table = table
        }
    }

    setTable(table: ApplicationTable) {
        this.application = table.application
        this.table = table
    }

    override getPermissionName(): string {
        return this.application?.data
            ? super.getPermissionName().replace('{application_name}', this.application.data.name)
            : ''
    }

    override getEndPoint(useEntityId: boolean = false): string {
        return this.table?.data
            ? super.getEndPoint(useEntityId)
                    .replace('{application_slug}', (this.application?.data as GenericApplicationData).slug)
                    .replace('{application_table_slug}', this.table.data.slug)
            : ''
    }

    override newStatic(data: any | object | null = null, meta: ShowMeta | null = null): this {
        const instance = new Entity(this.table) as this
        instance.data = data
        instance.meta = meta
        instance.parentEndPoint = this.parentEndPoint
        return instance
    }
}
